import * as e from "react";
const n = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 64, height: 64, viewBox: "0 0 64 64", fill: "#191919", ...t }, /* @__PURE__ */ e.createElement("style", null, `
    .spin {
      animation: rotate 3s linear infinite;
      transform-box: fill-box;
      transform-origin: 50% 50%;
    }
    @keyframes rotate {
      to { transform: rotate(360deg); }
    }
  `), /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", { d: "M52.4749 47.5251L50 40L47.5251 47.5251L40 50L47.5251 52.4749L50 60L52.4749 52.4749L60 50L52.4749 47.5251Z" }), /* @__PURE__ */ e.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", className: "spin", d: "M30 4L36.4347 23.5653L56 30L36.4347 36.4347L30 56L23.5653 36.4347L4 30L23.5653 23.5653L30 4ZM33.266 26.734L43.1967 30L33.266 33.266L30 43.1967L26.734 33.266L16.8033 30L26.734 26.734L30 16.8033L33.266 26.734Z" })));
export {
  n as default
};
